"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var Spotlight = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_Spotlight_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.995 12.38a.532.532 0 0 1-.064-.66A6.968 6.968 0 0 0 15 8a6.968 6.968 0 0 0-1.07-3.72.532.532 0 0 1 .065-.66.478.478 0 0 1 .744.068A7.962 7.962 0 0 1 16 8a7.963 7.963 0 0 1-1.26 4.312.478.478 0 0 1-.745.067ZM2.005 3.621c.175.175.195.45.064.66A6.967 6.967 0 0 0 1 8c0 1.367.392 2.642 1.069 3.72.131.209.11.484-.064.659a.478.478 0 0 1-.745-.067A7.962 7.962 0 0 1 0 8c0-1.588.463-3.068 1.26-4.312a.478.478 0 0 1 .745-.067ZM3.62 2.005c.176.175.45.196.66.064A6.967 6.967 0 0 1 8 1c1.367 0 2.642.392 3.72 1.069.209.131.484.11.659-.064a.478.478 0 0 0-.067-.745A7.962 7.962 0 0 0 8 0a7.963 7.963 0 0 0-4.312 1.26.478.478 0 0 0-.067.745ZM12.379 13.995a.532.532 0 0 0-.66-.064A6.967 6.967 0 0 1 8 15a6.968 6.968 0 0 1-3.72-1.07.532.532 0 0 0-.66.065.478.478 0 0 0 .068.744A7.962 7.962 0 0 0 8 16a7.963 7.963 0 0 0 4.312-1.26.478.478 0 0 0 .067-.745ZM11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 8A6 6 0 1 1 2 8a6 6 0 0 1 12 0Zm-1 0A5 5 0 1 1 3 8a5 5 0 0 1 10 0Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_Spotlight_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = Spotlight;
exports["default"] = _default;